import React, { lazy } from "react";
import { Route } from "react-router-dom";
import { PrivateRoute } from "components/global/PrivateRoute";

const UserRoles = lazy(() => import("scenes/admin/user_roles"));
const UserRole = lazy(() => import("scenes/admin/user_roles/user_role"));
const UserSessions = lazy(() => import("scenes/admin/user_session"));
const UserSession = lazy(() => import("scenes/admin/user_session/session"));
const Profile = lazy(() => import("scenes/user/profile"));
const UserList = lazy(() => import("scenes/user/list"));
const UserDetail = lazy(() => import("scenes/user/detail"));
const Preferences = lazy(() => import("scenes/preferences"));
const TablePageRowDetail = lazy(() => import("scenes/global/TablePageRowDetail"));

export const adminRoutes = [
  <Route
    key="sessions"
    path="/sessions"
    element={
      <PrivateRoute role="SuperAdmin,CustomerAdmin">
        <UserSessions />
      </PrivateRoute>
    }
  />,
  <Route
    key="sessions-id"
    path="/sessions/:id"
    element={
      <PrivateRoute role="SuperAdmin,CustomerAdmin">
        <UserSession />
      </PrivateRoute>
    }
  />,
  <Route
    key="roles"
    path="/roles"
    element={
      <PrivateRoute>
        <UserRoles />
      </PrivateRoute>
    }
  />,
  <Route
    key="roles-id"
    path="/roles/:id"
    element={
      <PrivateRoute>
        <UserRole />
      </PrivateRoute>
    }
  />,
  <Route
    key="user"
    path="/user"
    element={
      <PrivateRoute>
        <UserList />
      </PrivateRoute>
    }
  />,
  <Route
    key="user-name"
    path="/user/:username"
    element={
      <PrivateRoute>
        <UserDetail />
      </PrivateRoute>
    }
  />,
  <Route
    key="profile"
    path="/profile"
    element={
      <PrivateRoute>
        <Profile />
      </PrivateRoute>
    }
  />,
  <Route
    key="preference"
    path="/preference"
    element={
      <PrivateRoute>
        <Preferences />
      </PrivateRoute>
    }
  />,
  <Route
    key="preference-id"
    path="/preference/:id"
    element={
      <PrivateRoute>
        <TablePageRowDetail serviceType={"preference"} />
      </PrivateRoute>
    }
  />,
];

export default adminRoutes;
